import type { FC, ReactElement } from 'react';
import { ExclamationCircleIcon } from '@patternfly/react-icons/dist/dynamic/icons/exclamation-circle-icon';
import { ExclamationTriangleIcon } from '@patternfly/react-icons/dist/dynamic/icons/exclamation-triangle-icon';
import { AlertSeverity } from '@console/dynamic-plugin-sdk';

interface AlertSeverityIconProps {
  severityAlertType: AlertSeverity;
  fontSize?: number;
}

export const AlertSeverityIcon: FC<AlertSeverityIconProps> = ({
  severityAlertType,
  fontSize,
}): ReactElement => {
  switch (severityAlertType) {
    case AlertSeverity.Critical:
      return (
        <ExclamationCircleIcon
          style={{
            fontSize,
            fill: 'var(--pf-t--global--icon--color--status--danger--default)',
          }}
        />
      );
    case AlertSeverity.Warning:
    default:
      return (
        <ExclamationTriangleIcon
          style={{
            fontSize,
            fill: 'var(--pf-t--global--icon--color--status--warning--default)',
          }}
        />
      );
  }
};

export default AlertSeverityIcon;
